import { useIntl } from 'react-intl';

import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { XRayLibraryAdmin } from '~/features/x-ray/library/ModelLibraryAdmin';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const intl = useIntl();
  const { navigate } = useRouting();
  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'XRayLibraryAdminPage.pageTitle',
        defaultMessage: 'Model Library Admin Management',
        description: 'Page title for X-Ray model library admin management page',
      })}
      nav={{
        actions: [
          {
            text: intl.formatMessage({
              id: 'ModelLibraryAdmin.customAiBreadcrumb',
              defaultMessage: 'Custom AI',
              description: 'Breadcrumb link text for Custom AI',
            }),
            onClick: () => navigate(RoutePathType.AutomationHubFields),
          },
          {
            text: intl.formatMessage({
              id: 'ModelLibraryAdmin.modelLibraryBreadcrumb',
              defaultMessage: 'Model Library',
              description: 'Breadcrumb link text for Model Library',
            }),
            onClick: () => navigate(RoutePathType.XRayLibrary),
          },
          {
            text: intl.formatMessage({
              id: 'ModelLibraryAdmin.adminManagementBreadcrumb',
              defaultMessage: 'Admin Management',
              description:
                'Breadcrumb text for Admin Management of Model Library',
            }),
          },
        ],
      }}
    >
      <XRayLibraryAdmin />
    </PageLayout>
  );
};

export default Page;
